// src/components/chat/BookmarkFavorites.jsx
import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Settings } from 'lucide-react';


const BookmarkQuickLinks = ({ 
  bookmarks = [], 
  onSelectBookmark
}) => {

    //console.log(bookmarks);
    
  return (
    
           
          <div className="flex flex-row space-x-2 ">
            {[...bookmarks]
              .sort((a, b) => a.order - b.order)
              .map((bookmark) => (
              <motion.div
                key={bookmark.id}
                className="bg-zinc-800/50 hover:bg-zinc-700/50 p-3 rounded-lg cursor-pointer"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                onClick={() => onSelectBookmark(bookmark)}
              >
                <div className="flex items-center space-x-3">
                  <div className={`p-2 rounded-full ${bookmark.icon.bgColor} text-white`}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      {bookmark.icon.name === 'bookmark' && <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>}
                      {bookmark.icon.name === 'star' && <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>}
                      {bookmark.icon.name === 'heart' && <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>}
                      {bookmark.icon.name === 'file-text' && <><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path><polyline points="14 2 14 8 20 8"></polyline><line x1="16" y1="13" x2="8" y2="13"></line><line x1="16" y1="17" x2="8" y2="17"></line><polyline points="10 9 9 9 8 9"></polyline></>}
                      {bookmark.icon.name === 'message-square' && <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"></path>}
                      {bookmark.icon.name === 'lightbulb' && <path d="M9 18h6M10 22h4M15.09 14c.18-.98.65-1.74 1.41-2.5A4.65 4.65 0 0 0 18 8A6 6 0 0 0 6 8c0 1 .23 2.23 1.5 3.5A4.61 4.61 0 0 1 8.91 14"></path>}
                      {bookmark.icon.name === 'check-circle' && <><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></>}
                      {bookmark.icon.name === 'alert-circle' && <><circle cx="12" cy="12" r="10"></circle><line x1="12" y1="8" x2="12" y2="12"></line><line x1="12" y1="16" x2="12.01" y2="16"></line></>}
                    </svg>
                  </div>
                   
                    {/* <span className="hidden group-hover:inline">{bookmark.name}</span> */}
                  
                </div>
              </motion.div>
            ))}
            
          </div>
        
  );
};

export default BookmarkQuickLinks;